/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable object-shorthand */
/* eslint-disable no-param-reassign */
import jQuery from "jquery";

// eslint-disable-next-line no-unused-vars
import dataTableDefinitions from "./dataTableDefinitions";
// import JsonTotal from './JsonTotal';
import resultHeader from "./resultHeader";
import SearchFilterbarBaseFeature from "./searchFilterbarBase";

export class SearchFilterbar extends SearchFilterbarBaseFeature {
	constructor(element) {
		super(element);

		dataTableDefinitions(this);
		this.finishSetup(this.initDataTables, this.totalHitsRender);
		if (!this.isSitecore) {
			this.submitClick();
		}

		this.log("SearchFilterbar");
	}

	// Render the headline with total hits
	totalHitsRender() {
		// Use this for making your own json call to the data from the endpoint
		// eslint-disable-next-line max-len
		// let queryString = `draw=1&searchWord=${this.dom.input.value}&filters=${this.selectBoxValues.toString()}&contextId=${this.settings.contextId}&start=0&searchType=${this.settings.searchType}&pageSize=10`;
		// JsonTotal(this.settings.endPoint, this, queryString);

		const hitsOnLoad = this.$datatable.DataTable().ajax.json().recordsTotal;
		// let firstLoad = true
		this.hits = 0;

		this.$datatable.DataTable().on("xhr", () => {
			const json = this.$datatable.DataTable().ajax.json();
			this.hits = json.recordsTotal;
			this.createHeaderString(this.hits);
			if (this.hits === 0) {
				this.ifNoResults();
			} else {
				jQuery(".dataTable").removeClass("dataTable--empty");
			}
		});

		if (this.firstLoad === true) {
			this.createHeaderString(hitsOnLoad);
			if (hitsOnLoad === 0) {
				this.ifNoResults();
			}
			this.firstLoad = false;
		}
	}

	// Create the various headerstrings based on values from data-settings, userinput and total hits
	// Some lists require one header on load and another after user search. Therefor conditionals
	createHeaderString(totalHits) {
		resultHeader(this, totalHits);
	}

	// eslint-disable-next-line max-len
	// Make ready for loading datatables with the correct settings and data dependent on data-settings values(context)
	initDataTables() {
		this.apiUrl = this.settings.endPoint; // Endpoint comes from the HTML data-attribute
		switch (this.settings.searchType) {
			case "vvae":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsKnowledgeAndOpgaver;
				this.dataTableDefs = this.defKnowledgeAndOpgaver;
				break;
			case "enafos":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsKnowledgeAndOpgaver;
				this.dataTableDefs = this.defKnowledgeAndOpgaver;
				break;
			case "knowledge":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsKnowledgeAndOpgaver;
				this.dataTableDefs = this.defKnowledgeAndOpgaver;
				break;
			case "news":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsList;
				this.dataTableDefs = this.defList;
				this.initDataTableList();
				break;
			case "opgaver":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsKnowledgeAndOpgaver;
				this.dataTableDefs = this.defKnowledgeAndOpgaver;
				this.initDataTableList();
				break;
			case "publications":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list");
				this.dataTableColumns = this.columnsList;
				this.dataTableDefs = this.defList;
				this.initDataTableList();
				break;
			case "reports":
				this.$datatable = jQuery(".o-search-result-standard__table");
				this.$container = jQuery(".o-search-result-standard");
				this.dataTableColumns = this.columnsReports;
				this.dataTableDefs = this.defReports;
				this.initDataTableList();
				break;
			case "puljer":
				this.$datatable = jQuery(".o-search-result-standard__table");
				this.$container = jQuery(".o-search-result-standard");
				this.dataTableColumns = this.columnsPools;
				this.dataTableDefs = this.defPools;
				this.initDataTableList();
				break;
			// eslint-disable-next-line no-case-declarations
			case "events":
				this.$datatable = jQuery(".o-search-result-events__table");
				this.$container = jQuery(".o-search-result-events");
				this.dataTableColumns = this.columnsEvents;
				this.dataTableDefs = this.defEvents;
				this.initDataTableList();
				break;
			case "contacts":
				this.$datatable = jQuery(".o-search-result-phonebook__table");
				this.$container = jQuery(".o-search-result-phonebook");
				this.dataTableColumns = this.columnsPhonebook;
				this.dataTableDefs = this.defPhonebook;
				this.initDataTableList();
				break;
			case "habilitet":
				this.$datatable = jQuery(".o-search-result-standard__table");
				this.$container = jQuery(".o-search-result-standard");
				this.dataTableColumns = this.columnsHabilitet;
				this.dataTableDefs = this.defHabilitet;
				this.initDataTableList();
				break;
			case "materials":
				this.$datatable = jQuery(".o-search-result-materials__table");
				this.$container = jQuery(".o-search-result-materials");
				this.dataTableColumns = this.columnsMaterials;
				this.dataTableDefs = this.defMaterials;
				this.initDataTableList();
				break;
			case "fou":
				this.$datatable = jQuery(".o-search-result-materials__table");
				this.$container = jQuery(".o-search-result-materials");
				this.dataTableColumns = this.columnsMaterials;
				this.dataTableDefs = this.defMaterials;
				this.initDataTableList();
				break;
			case "fou-search-global":
				this.$datatable = jQuery(".o-search-result-list__table");
				this.$container = jQuery(".o-search-result-list__container");
				this.dataTableColumns = this.searchItemFOU;
				this.dataTableDefs = this.defSearchItem;
				this.initDataTableList();
				break;
			default:
		}
	}

	// The MOTHR
	// Datatable init with settings from previous functions
	initDataTableList() {
		const me = this;
		this.$datatable.DataTable({
			// If no results do not show the pagination
			// eslint-disable-next-line quote-props
			// eslint-disable-next-line func-names
			fnDrawCallback: function (oSettings) {
				// eslint-disable-next-line no-underscore-dangle
				if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
					jQuery(oSettings.nTableWrapper).find(".dataTables_paginate").hide();
					jQuery(".dataTables_wrapper").addClass(
						"dataTables_wrapper--no-paging"
					);
				} else {
					jQuery(oSettings.nTableWrapper).find(".dataTables_paginate").show();
				}
				const $table = jQuery(oSettings.nTable).DataTable();
				const info = $table.page.info();
				const url = new URL(window.location.href);
				url.hash = `/side-${info.page + 1}`;
				window.history.pushState({ path: url.href }, '', url.href);
			},
			processing: false,
			serverSide: true,
			searching: false,
			ordering: false,
			deferRender: true,
			lengthChange: false,
			info: true,
			paging: true,
			pagingType: "full_numbers",
			pageLength: Number(me.settings.pageSize),
			retrieve: true,
			language: {
				info: "_TOTAL_",
				emptyTable: me.settings.noResults,
				paginate: {
					next: '<span class="a-icon m-link-icon__icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_right_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>',
					previous:
						'<span class="a-icon m-link-icon__icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_left_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>',
					first:
						'<span class="a-icon m-link-icon__icon first-icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_left_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span><span class="first-text">Første</span> ',
					last: '<span class="last-text">Sidste</span><span class="a-icon m-link-icon__icon last-icon"><svg class="a-icon__asset"><use xlink:href="#Arrow_right_icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg></span>',
				},
			},
			ajax: {
				url: this.apiUrl,
				// eslint-disable-next-line object-shorthand
				// eslint-disable-next-line func-names
				data: function (d) {
					d.filters = me.selectBoxValues.toString(); // Array of values from applied select box filters
					d.searchWord = me.dom.input.value;
					d.contextId = me.settings.contextId; // value from the data-attribute in HTML
					d.searchType = me.settings.searchType; // value from the data-attribute in HTML
					d.pageSize = me.settings.pageSize; // value from the data-attribute in HTML
				},
			},
			// eslint-disable-next-line func-names
			initComplete: function (settings, json) {
				me.showFirstHeaderInfo = true;
				if (
					me.settings.searchType === "news" ||
					me.settings.searchType === "puljer" ||
					me.settings.searchType === "opgaver" ||
					me.settings.searchType === "fou" ||
					me.settings.searchType === "fou-search-result"
				) {
					me.showFirstHeaderInfo = false;
				}
				me.totalHitsRender();
				me.rowClick();
				me.knowledgeFirstSubmit = true;
			},
			columnDefs: me.dataTableDefs,
			columns: me.dataTableColumns,
		});
	}
}

export default SearchFilterbar;
